import type { OnInit } from '@angular/core';
import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { DeliveryTrackerDocumentsComponent } from '@features/organization/components/delivery-tracker-detail/components/delivery-tracker-documents/delivery-tracker-documents.component';
import { DeliveryTrackerStatusComponent } from '@features/organization/components/delivery-tracker-detail/components/delivery-tracker-status/delivery-tracker-status.component';
import { DeliveryTrackerEmailFacade } from '@features/organization/components/delivery-tracker-detail/facades/delivery-tracker-email.facade';
import { DeliveryTrackerEmailFilterStore } from '@features/organization/components/delivery-tracker-detail/stores/delivery-tracker-email-filter.store';
import { TranslocoDirective } from '@jsverse/transloco';
import type { ResponseDeliveryTrackerCacheDto } from '@kerberos-compliance/compliance-shared-ts/features/delivery/dtos/response.delivery-tracker.cache-dto';
import type { TableQueryParameters } from '@kerberos-compliance/compliance-shared-ui';
import { AppDatatableComponent, FILTER_FACADE_TOKEN, FilterComponent } from '@kerberos-compliance/compliance-shared-ui';

@Component({
  selector: 'aad-delivery-tracker-email-list',
  imports: [
    AppDatatableComponent,
    FilterComponent,
    DeliveryTrackerStatusComponent,
    DeliveryTrackerDocumentsComponent,
    TranslocoDirective,
  ],
  providers: [
    DeliveryTrackerEmailFacade,
    DeliveryTrackerEmailFilterStore,
    { provide: FILTER_FACADE_TOKEN, useExisting: DeliveryTrackerEmailFacade },
  ],
  templateUrl: 'delivery-tracker-email-list.component.html',
  styleUrl: 'delivery-tracker-email-list.component.less',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DeliveryTrackerEmailListComponent implements OnInit {
  public readonly deliveryTracker = input.required<ResponseDeliveryTrackerCacheDto>();

  protected readonly deliveryTrackerEmailFacade = inject(DeliveryTrackerEmailFacade);

  protected readonly loading = computed(() =>
    this.deliveryTrackerEmailFacade.isLoadingForTracker(this.deliveryTracker().id),
  );

  protected readonly tableColumns = this.deliveryTrackerEmailFacade.tableColumns;

  protected readonly emails = this.deliveryTrackerEmailFacade.emailTrackerById;

  public ngOnInit(): void {
    this.deliveryTrackerEmailFacade.setPeriodRange(
      this.deliveryTracker().periodStart,
      this.deliveryTracker().periodEnd,
    );
    this.deliveryTrackerEmailFacade.initialize();
  }

  /**
   * Loads email data from server based on table query parameters.
   *
   * @param {TableQueryParameters} parameters - Query parameters including pagination, sorting, and filters
   * @returns {void} This method does not return a value
   */
  public loadDataFromServer(parameters: TableQueryParameters): void {
    this.deliveryTrackerEmailFacade.loadDataFromServer(parameters);
  }
}
